/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import Container from 'blocks/Container/Container';
import { Row, Column } from 'hedron';
import DebugOptionsService from 'services/DebugOptions.service';
import { DEBUG_OPTION_GRID, DEBUG_VALUE_GRID_OFF } from 'common/consts/debugOptionConsts';
import { observer } from 'mobx-react';
import { Bind } from 'lodash-decorators';

@observer
class DebugGridHelper extends Component {
  componentDidMount() {
    DebugOptionsService.subscribe(this.onDebugOptionsChange);
  }

  componentWillUnmount() {
    DebugOptionsService.unsubscribe(this.onDebugOptionsChange);
  }

  @Bind
  onDebugOptionsChange() {
    this.forceUpdate();
  }

  render() {
    if (DebugOptionsService.getOptionValueByName(DEBUG_OPTION_GRID) === DEBUG_VALUE_GRID_OFF) {
      return null;
    }
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        width: '100vw',
        zIndex: 9999,
      }}
      >
        <Container debug>
          <Row style={{
            height: '100vh',
          }}
          >
            {[...Array(12)].map((i, index) => <Column key={index} xs={1} />)}
          </Row>
        </Container>
      </div>
    );
  }
}

export default DebugGridHelper;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugGridHelper/index.jsx